// extracted by mini-css-extract-plugin
export default {"add-folder-button":"AddFolderButton_add-folder-button__KtxXg","add-folder-icon":"AddFolderButton_add-folder-icon__R7XAN"};